import { addDays, isBefore, parseISO } from 'date-fns';
import type { RoadStatusLayerOptions } from '../Layers/Layers.types';
import { RoadStatusLayer } from '../Layers/RoadStatusLayer';
import RoadCondition from '../PopupTemplates/RoadCondition';
import { type TrafikverketRoadCondition } from '../Sources/RoadConditionMessage';
import { RoadConditionSectionSource } from '../Sources/RoadConditionSection';
import { RoadConditionStatusSource } from '../Sources/RoadConditionStatus';

export const roadCondition = function (region: string, options?: Partial<RoadStatusLayerOptions>): RoadStatusLayer {
    const defaultOptions: RoadStatusLayerOptions = {
        color: {
            '0': '#ccc',
            '1': '#0c0',
            '2': '#ff0',
            '3': '#f00',
            '4': '#00f',
        },
        getStatus: function (section: TrafikverketRoadCondition) {
            if (section.startTime != null && isBefore(parseISO(section.startTime), addDays(new Date(), -1))) {
                return 0;
            }
            return section.conditionCode;
        },
        getStatusCode: (status) => status as number,
        source: new RoadConditionSectionSource(region),
        statusSource: new RoadConditionStatusSource(region, {
            updateInterval: 60,
        }),
        tooltipTemplate: RoadCondition,
    };

    return new RoadStatusLayer({ ...defaultOptions, ...options });
};
